import React from 'react'
import fullLogo from '../../assets/fullLogo.svg'

const FullLogo = () => {
  return (
    <img
      src={fullLogo}
      alt='Boodhana Logo'
      style={{ width: '200px' }}
    />
  )
}

export default FullLogo